import { ACTIVE_CONTROLLER} from '../constants';

export default function update(state ={nextActive:' non-active', prevActive:' non-active',pauseActive:' ', clickCounter:1}, action) {
    switch (action.type) {
        case ACTIVE_CONTROLLER:
            return action.controlState
    }
    return state;
}